import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "~/components/SEO";

export const Route = createFileRoute("/cookie_policy")({
  component: CookiePolicy,
});

function CookiePolicy() {
  return (
    <>
      <SEO
        title="Cookie Policy"
        socialTitle="Ristorante Tennis & Gourmet Morbegno | Cookie Policy"
        description="Cookie Policy di Tennis Gourmet. Informazioni dettagliate sui cookie utilizzati sul nostro sito web e come gestire le tue preferenze."
        keywords="cookie policy Tennis Gourmet, gestione cookie, preferenze cookie, cookie tecnici, cookie analitici"
        url="https://www.ristorantetennisgourmet.it/cookie_policy"
      />
      <section className="tg-section__wrapper pt-25 pb-12 lg:pt-50 lg:pb-25">
        <div className="tg-section__grid">
          <div className="col-span-12 space-y-8 lg:space-y-12 2xl:col-start-3 2xl:col-end-11">
            <div>
              <h2 className="tg-h3 mb-6">Cookie Policy</h2>
              <p className="tg-body mb-4">
                Questa Cookie Policy spiega cosa sono i cookie, come li utilizziamo sul
                sito web www.ristorantetennisgourmet.it e come puoi gestire le tue
                preferenze.
              </p>
              <p className="tg-body">
                Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">1. Cosa sono i Cookie</h3>
              <p className="tg-body mb-4">
                I cookie sono piccoli file di testo che vengono memorizzati sul tuo
                dispositivo quando visiti un sito web. Permettono al sito di ricordare le
                tue azioni e preferenze per un certo periodo di tempo.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">2. Tipi di Cookie Utilizzati</h3>

              <div className="mb-6">
                <h4 className="tg-h5 mb-3">Cookie Tecnici Necessari</h4>
                <p className="tg-body mb-3">
                  Questi cookie sono essenziali per il funzionamento del sito web e non
                  possono essere disabilitati. Includono:
                </p>
                <ul className="tg-body list-disc space-y-2 pl-6">
                  <li>
                    <strong>Cookie di sessione:</strong> Mantengono la tua sessione attiva
                    durante la navigazione
                  </li>
                  <li>
                    <strong>Cookie di preferenze:</strong> Ricordano le tue impostazioni
                    (es. tema scuro/chiaro)
                  </li>
                  <li>
                    <strong>Cookie di sicurezza:</strong> Proteggono il sito da attacchi e
                    garantiscono la sicurezza
                  </li>
                </ul>
              </div>

              <div className="mb-6">
                <h4 className="tg-h5 mb-3">Cookie Analitici (Opzionali)</h4>
                <p className="tg-body mb-3">
                  Questi cookie ci aiutano a capire come i visitatori interagiscono con il
                  nostro sito web. Richiedono il tuo consenso esplicito:
                </p>
                <ul className="tg-body list-disc space-y-2 pl-6">
                  <li>
                    <strong>Google Analytics:</strong> Raccoglie dati anonimi su visite,
                    pagine visualizzate e comportamento degli utenti
                  </li>
                  <li>
                    <strong>Durata:</strong> Fino a 2 anni
                  </li>
                  <li>
                    <strong>Finalità:</strong> Migliorare l'esperienza utente e
                    ottimizzare il contenuto del sito
                  </li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">3. Cookie di Terze Parti</h3>
              <div className="tg-body space-y-4">
                <p>
                  <strong>Google Analytics (Google LLC)</strong>
                </p>
                <ul className="list-disc space-y-1 pl-6">
                  <li>Finalità: Analisi del traffico web e comportamento degli utenti</li>
                  <li>Durata: Fino a 2 anni</li>
                  <li>
                    Privacy Policy:
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-tennis-400 ml-1 underline transition-colors"
                    >
                      https://policies.google.com/privacy
                    </a>
                  </li>
                  <li>
                    Opt-out:
                    <a
                      href="https://tools.google.com/dlpage/gaoptout"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-tennis-400 ml-1 underline transition-colors"
                    >
                      https://tools.google.com/dlpage/gaoptout
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">4. Gestione delle Preferenze Cookie</h3>
              <div className="tg-body space-y-4">
                <p>Puoi gestire le tue preferenze sui cookie in diversi modi:</p>
                <ul className="list-disc space-y-2 pl-6">
                  <li>
                    <strong>Banner Cookie:</strong> Quando visiti il sito per la prima
                    volta, puoi scegliere di accettare o rifiutare i cookie non essenziali
                  </li>
                  <li>
                    <strong>Impostazioni Browser:</strong> Puoi configurare il tuo browser
                    per bloccare o eliminare i cookie
                  </li>
                  <li>
                    <strong>Revoca Consenso:</strong> Puoi revocare il consenso in
                    qualsiasi momento cancellando i cookie del browser o contattandoci
                  </li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">5. Conseguenze del Rifiuto dei Cookie</h3>
              <div className="tg-body space-y-4">
                <p>
                  <strong>Cookie Tecnici:</strong> Il rifiuto di questi cookie può
                  compromettere il funzionamento del sito web.
                </p>
                <p>
                  <strong>Cookie Analitici:</strong> Il rifiuto non influisce sulla
                  navigazione, ma ci impedisce di migliorare l'esperienza utente basandoci
                  sui dati di utilizzo.
                </p>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">6. Aggiornamenti della Cookie Policy</h3>
              <p className="tg-body">
                Questa Cookie Policy può essere aggiornata periodicamente. Ti consigliamo
                di consultarla regolarmente per rimanere informato su come utilizziamo i
                cookie.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">7. Contatti</h3>
              <p className="tg-body">
                Per domande riguardo questa Cookie Policy o per esercitare i tuoi diritti,
                contatta Tennis Gourmet:
              </p>
              <div className="tg-body mt-4 space-y-2">
                <p>
                  <strong>Email:</strong>
                  <a
                    href="mailto:info@ristorantetennisgourmet.it"
                    className="hover:text-tennis-400 ml-1 underline transition-colors"
                  >
                    info@ristorantetennisgourmet.it
                  </a>
                </p>
                <p>
                  <strong>Telefono:</strong>
                  <a
                    href="tel:+390342330685"
                    className="hover:text-tennis-400 ml-1 underline transition-colors"
                  >
                    +39 0342 330685
                  </a>
                </p>
                <p>
                  <strong>Indirizzo:</strong> Via Gregorini, 89 - 23017 Morbegno (SO)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
